import React from 'react'
import './HeroSection.css'
import {Button} from './Button';

const HeroSection = () => {
  return (
    <div className='hero-container'>
        <video src='/videos/videos.mp4' autoPlay loop muted/>
        <h1>GET YOUR RECIPE</h1>
        <p>Let's Search Recipe to Make Your Cook</p>
        <div className='hero-btns'>
            <Button className='btns' buttonStyle="btn--outline" buttonSize="btn--large" >
                Get Started
            </Button>
            <Button className='btns' buttonStyle="btn--primary" buttonSize="btn--large" >
                Watch Trailer <i className='far fa-play-circle'></i>
            </Button>
        </div>
    </div>
  )
}

export default HeroSection